import React from 'react';
import PropTypes from 'prop-types';

import style from './body-cover.module.less';

export const Cover = ({ onClick }) => <div className={style.cover} onClick={onClick} />;

Cover.propTypes = {
  onClick: PropTypes.func.isRequired,
};
